export default "__VITE_PUBLIC_ASSET__899d5256__"